<template>
    <DashboardGraph :icons="icons" :title="title" :chart_type="chart_type" :chart_handle="chart_layout" :load_url="load_url"></DashboardGraph>
</template>

<script>
    import DashboardGraph from '../../widgets/DashboardGraph';
    export default {
        name: 'CallsPerCampaignPenitrationByUser',
        components: {DashboardGraph},
        props:{
            user: String,
        },
        data() {
            var labels = [];
            for(var i = 8; i <= 17;i++){
                labels[i-8] = 'Hour '+i;
            }
            return {
                icons:labels,
                chart_type: 'bar',
                color: '#2129d5',
                title: 'Calls per Campaign Penetration For '+this.user,
                load_url: '/dashboards/CallsPerCampaignPenitrationByUser/' + this.user,
                time_wait: 10000,
                chart_layout: [
                    {
                        'label': 'Calls per Campaign Penetration For' + this.user,
                        'backgroundColor': 'rgb(0,0,158)', //can be an array for other graph types
                        'borderColor': '#00b',
                        'pointBackgroundColor': 'rgba(220, 220, 220, 0)',
                        'pointBorderColor': '#fff',
                        'pointHighlightFill': 'rgba(220, 220, 220, 0)',
                        'pointHighlightStroke': 'rgba(220, 220, 220, 0)',
                    },
                ],
            };
        },
    };
</script>

<style scoped>

</style>